<template>
    <hts-drawer
        v-model="visible"
        color="main"
        :title="$t('labels.addDocument')"
        :submit="visibleCreate"
        :rules="rulesDocument"
        @close="closeOverSide">
        <hts-card :title="$t('labels.generalInformation')">
            <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                <hts-form-select
                    v-model="dataDocument.type"
                    :label="$t('labels.documentType')"
                    required
                    :items="listTypeDocument || []"
                    key-id="key"
                    key-label="value"
                    :color="color"
                    name="documentType"
                    prop="documentType" />
                <hts-form-input
                    v-model="dataDocument.fileName"
                    :label="$t('labels.documentFileName')"
                    name="documentFileName"
                    prop="documentFileName" />
                <hts-form-select
                    v-if="dataDocument.type === 'HEALTHCHECK'"
                    v-model="dataDocument.healthResult"
                    :label="$t('labels.driverModule.healthCheck.value')"
                    :items="healthResults || []"
                    required
                    key-id="key"
                    key-label="value"
                    :color="color"
                    name="driverModule.healthCheck.value"
                    prop="healthCheck" />
                <hts-form-date
                    v-if="dataDocument.type === 'HEALTHCHECK' && dataDocument.healthResult"
                    v-model="dataDocument.expiredDate"
                    :label="$t('labels.expiredDate')"
                    :color="color"
                    name="expiredDate"
                    prop="expiredDate" />
                <hts-form-file
                    v-model="fileDocument"
                    type="file"
                    required
                    :label="$t('labels.document')"
                    :color="color"
                    name="document"
                    prop="document" />
                <hts-form-date
                    v-if="dataDocument.type === 'CONTRACT'"
                    v-model="dataDocument.expiredDate"
                    :label="$t('labels.expiredDate')"
                    :color="color"
                    name="expiredDate"
                    prop="expiredDate" />
                <hts-form-input
                    v-model="dataDocument.description"
                    :label="$t('labels.description')"
                    :color="color"
                    name="description"
                    prop="description" />
            </div>
            <hts-modal
                :show="openPopupConfirmDocument"
                :title="$t('labels.confirmCreateDocument')"
                type="confirm"
                :content="labelConfirmDocument"
                @hide="openPopupConfirmDocument = false"
                @confirm="handleSubmitFormAddDocumentDriver" />
        </hts-card>
    </hts-drawer>
</template>

<script lang="ts" setup>
import form from './imports/form'
import data from './imports/data'
const { listTypeDocument, privacyDocument, healthResults } = data()

const props = defineProps({
  codeDriver: {
    type: String
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 2
  }
})

const { color } = toRefs(props)

const visible = ref(false)

const initForm = {
  driverDocument: '',
  driver: '',
  fileName: '',
  description: '',
  type: '',
  expiredDate: '',
  healthResult: 1
} as { [key: string]: any }

const dataDocument = reactive({ ...initForm })
const { rulesDocument } = form
const emits = defineEmits(['close', 'refreshTables', 'update:show'])
const fileDocument = ref<File | string | undefined>(undefined)

const resetForm = () => {
  fileDocument.value = undefined
  Object.assign(dataDocument, { ...initForm })
}
const open = () => {
  visible.value = true
}
defineExpose({
  open
})

const openPopupConfirmDocument = ref(false)

const labelConfirmDocument = ref('')

const visibleCreate = async () => {
  const { expiredDate, type, healthResult } = dataDocument
  if (!['HEALTHCHECK', 'CONTRACT'].includes(type)) {
    return await handleSubmitFormAddDocumentDriver()
  }

  if (expiredDate && new Date(`${expiredDate} 23:59:59`).getTime() < new Date().getTime()) {
    if (type === 'HEALTHCHECK' && !healthResult) {
      return await handleSubmitFormAddDocumentDriver()
    }
    labelConfirmDocument.value = $t('labels.contentConfirmDocumentDriverExpiredDate')
    openPopupConfirmDocument.value = true
    return
  }

  if (!expiredDate) {
    if (!healthResult) {
      return await handleSubmitFormAddDocumentDriver()
    }

    labelConfirmDocument.value = $t('labels.contentConfirmExpiredDateEmpty')
    openPopupConfirmDocument.value = true
    return
  }

  await handleSubmitFormAddDocumentDriver()
}

const handleSubmitFormAddDocumentDriver = async () => {
  const dataForm = new FormData()

  fileDocument.value && dataForm.append('driverDocument', fileDocument.value)
  dataDocument.fileName && dataForm.append('fileName', dataDocument.fileName)
  dataForm.append('driver', props.codeDriver || '')
  dataDocument.description && dataForm.append('description', dataDocument.description)
  dataDocument.type && dataForm.append('type', dataDocument.type)

  if (dataDocument.type === 'HEALTHCHECK') {
    typeof dataDocument.healthResult === 'number' && dataForm.append('healthResult', String(dataDocument.healthResult))
    dataDocument.expiredDate && dataForm.append('expiredDate', dataDocument.expiredDate)
  }

  if (dataDocument.type === 'CONTRACT') {
    dataDocument.expiredDate && dataForm.append('expiredDate', dataDocument.expiredDate)
  }

  const api = {
    method: 'POST',
    url: '/driver/document/upload'
  }

  const data: any = await $api(api, { body: dataForm })

  const resData: any = data?.data?.value
  if (resData?.success) {
    process.client && $toast().success($t('notifications.addSuccessDocument'))
    emits('close')
    emits('refreshTables')
    resetForm()
    visible.value = false
    openPopupConfirmDocument.value = false
  }
}

const closeOverSide = () => {
  visible.value = false
}
</script>
